<template>
	<nav class="_nav" ref="nav">
		<div
			class="_nav-wrapper"
			id="_nav"
			:class="[
				ShowThird || showDirection ? 'left-fixed' : '',
				darkMode ? 'dark-mode' : '',
				bxPanel ? 'bx-panel' : '',
			]"
		>
			<div class="_nav-container">
				<div class="_nav-all-directions__mob" @click="showAllDirection">
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="20"
						height="20"
						viewBox="0 0 20 20"
						fill="none"
					>
						<rect
							x="1"
							y="1.00073"
							width="6"
							height="6"
							rx="3"
							fill="#A3D562"
						></rect>
						<rect
							x="1"
							y="13.0007"
							width="6"
							height="6"
							rx="3"
							fill="#FFC9B5"
						></rect>
						<rect
							x="13"
							y="1.00073"
							width="6"
							height="6"
							rx="3"
							fill="#9AC3FF"
						></rect>
						<rect
							x="13"
							y="13.0007"
							width="6"
							height="6"
							rx="3"
							:fill="darkMode ? '#fff' : '#252628'"
						></rect>
					</svg>
				</div>
				<div class="_nav-logo" :class="darkMode ? 'dark-mode' : ''">
					<a href="/">
						<svg
							width="48"
							height="48"
							viewBox="0 0 48 48"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M47.9986 28.2603H0.0830078V31.0441H47.9986V28.2603Z"
								fill="#252628"
							/>
							<path
								d="M0.0830078 48.0002H3.03555V44.7946H19.8229V33.828H0.0830078V48.0002ZM3.03555 36.6118H16.8703V42.0108H3.03555V36.6118Z"
								fill="#252628"
							/>
							<path
								d="M22.6094 44.7947H33.7447V48.0003H36.7816V44.7947H47.9169V33.8281H22.6094V44.7947ZM36.7816 36.612H45.0487V42.0109H36.7816V36.612ZM25.5619 36.612H33.7447V42.0109H25.5619V36.612Z"
								fill="#252628"
							/>
							<path
								d="M25.4759 0H14.1719V25.3919H25.4759V0ZM22.5234 22.6081H17.1244V2.86819H22.5234V22.6081Z"
								fill="#252628"
							/>
							<path
								d="M31.2963 8.52021L36.6952 2.86819V25.4763H39.6478V8.52021L44.9624 2.86819V25.4763H47.9149V0H43.7814L39.6478 4.38664V0H35.5142L28.3438 7.42355V25.4763H31.2963V8.52021Z"
								fill="#252628"
							/>
							<path
								d="M8.35149 25.4763H11.304V22.6924V0H7.17047L0 7.42355V22.6081V25.3919H2.95255H8.35149V25.4763ZM3.0369 8.52021L8.43585 2.86819V22.6081H3.0369V8.52021Z"
								fill="#252628"
							/>
						</svg>
					</a>
				</div>
				<div
					class="_nav-all-directions"
					@click="showAllDirection"
					:class="darkMode ? 'dark-mode' : ''"
				>
					<span> Все направления </span>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="16"
						height="16"
						viewBox="0 0 16 16"
						fill="none"
					>
						<path
							d="M8.7926 10.9709C8.3923 11.4909 7.60809 11.4909 7.20779 10.9709L4.04342 6.86024C3.53722 6.20267 4.00599 5.25024 4.83583 5.25024H11.1646C11.9944 5.25024 12.4632 6.20267 11.957 6.86024L8.7926 10.9709Z"
							fill="#252628"
						></path>
					</svg>
				</div>
				<ul class="_nav-links _nav-main">
					<li v-for="item in navStore.getMainNav" :key="item.name">
						<a
							class="_nav-main__link"
							@click="navMainClick(item)"
							:href="item.url"
							:target="item._blank === 'Y' ? '_blank' : ''"
							data-metrika="menuSection"
							:class="[
								item.selected === 'Y' ? 'active' : '',
								darkMode ? 'dark-mode' : '',
							]"
						>
							{{ item.name }}
						</a>
					</li>
				</ul>
				<ul class="_nav-links _nav-inner">
					<li v-for="item in navStore.getInnerNav" :key="item.name">
						<a
							class="_nav-inner__link"
							@click="navMainClick(item)"
							:href="item.url"
							:target="item._blank === 'Y' ? '_blank' : ''"
							data-metrika="menuSection"
							:class="[
								item.selected === 'Y' ? 'active' : '',
								darkMode ? 'dark-mode' : '',
							]"
						>
							{{ item.name }}
						</a>
					</li>
				</ul>
				<div class="_nav-button__block">
					<ul class="_nav-button__list">
						<li class="_nav-button__lang" :class="darkMode ? 'dark-mode' : ''">
							<a href="#" @click="setLang" ref="selectLang">
								RU
								<svg
									xmlns="http://www.w3.org/2000/svg"
									width="16"
									height="16"
									viewBox="0 0 16 16"
									fill="none"
								>
									<path
										d="M8.7926 10.9709C8.3923 11.4909 7.60809 11.4909 7.20779 10.9709L4.04342 6.86024C3.53722 6.20267 4.00599 5.25024 4.83583 5.25024H11.1646C11.9944 5.25024 12.4632 6.20267 11.957 6.86024L8.7926 10.9709Z"
										fill="#252628"
									></path>
								</svg>
							</a>
							<transition name="fade-list">
								<div
									class="select-choose"
									v-if="openSelect"
									:class="darkMode ? 'dark-mode' : ''"
								>
									<ul>
										<li>
											<a
												class="select-choose__lang"
												href="http://domrf.com/cn/"
												target="_blank"
											>
												中文
											</a>
										</li>
										<li>
											<a
												class="select-choose__lang"
												href="http://domrf.com/"
												target="_blank"
											>
												EN
											</a>
										</li>
									</ul>
								</div>
							</transition>
						</li>
						<li
							class="_nav-button__search"
							:class="darkMode ? 'dark-mode' : ''"
						>
							<a href="/search/">
								<svg
									xmlns="http://www.w3.org/2000/svg"
									width="24"
									height="24"
									viewBox="0 0 24 24"
									fill="none"
								>
									<path
										fill-rule="evenodd"
										clip-rule="evenodd"
										d="M10.5 4.00024C7.18629 4.00024 4.5 6.68654 4.5 10.0002C4.5 13.314 7.18629 16.0002 10.5 16.0002C13.8137 16.0002 16.5 13.314 16.5 10.0002C16.5 6.68654 13.8137 4.00024 10.5 4.00024ZM2.5 10.0002C2.5 5.58197 6.08172 2.00024 10.5 2.00024C14.9183 2.00024 18.5 5.58197 18.5 10.0002C18.5 12.104 17.6879 14.0181 16.3602 15.4462L21.2071 20.2931C21.5976 20.6837 21.5976 21.3168 21.2071 21.7074C20.8166 22.0979 20.1834 22.0979 19.7929 21.7074L14.8202 16.7346C13.5741 17.5356 12.0913 18.0002 10.5 18.0002C6.08172 18.0002 2.5 14.4185 2.5 10.0002Z"
										fill="#252628"
									></path>
								</svg>
							</a>
						</li>
						<li class="_nav-button__lk" :class="darkMode ? 'dark-mode' : ''">
							<a href="https://lkz.ahml.ru/borrower" target="__blank">
								<svg
									xmlns="http://www.w3.org/2000/svg"
									width="24"
									height="24"
									viewBox="0 0 24 24"
									fill="none"
								>
									<g clip-path="url(#clip0_3647_455)">
										<path
											fill-rule="evenodd"
											clip-rule="evenodd"
											d="M12 7.00024C9.79086 7.00024 8 8.79111 8 11.0002C8 13.2094 9.79086 15.0002 12 15.0002C14.2091 15.0002 16 13.2094 16 11.0002C16 8.79111 14.2091 7.00024 12 7.00024ZM6 11.0002C6 7.68654 8.68629 5.00024 12 5.00024C15.3137 5.00024 18 7.68654 18 11.0002C18 14.314 15.3137 17.0002 12 17.0002C8.68629 17.0002 6 14.314 6 11.0002Z"
											fill="#252628"
										></path>
										<path
											fill-rule="evenodd"
											clip-rule="evenodd"
											d="M12 17.0002C10.7549 17.0002 9.53226 17.3247 8.45503 17.9402C7.37786 18.5557 6.48449 19.4403 5.8637 20.5041C5.58534 20.9811 4.973 21.1422 4.49599 20.8638C4.01898 20.5854 3.85794 19.9731 4.1363 19.4961C4.93491 18.1275 6.08249 16.9924 7.46278 16.2037C8.843 15.415 10.4077 15.0002 12 15.0002C13.5923 15.0003 15.1571 15.4151 16.5373 16.2038C17.9176 16.9925 19.0651 18.1277 19.8637 19.4963C20.1421 19.9733 19.981 20.5856 19.504 20.864C19.027 21.1423 18.4146 20.9812 18.1363 20.5042C17.5155 19.4404 16.6222 18.5558 15.545 17.9403C14.4678 17.3247 13.2451 17.0003 12 17.0002Z"
											fill="#252628"
										></path>
										<path
											fill-rule="evenodd"
											clip-rule="evenodd"
											d="M12 22.0002C17.5228 22.0002 22 17.5231 22 12.0002C22 6.4774 17.5228 2.00024 12 2.00024C6.47715 2.00024 2 6.4774 2 12.0002C2 17.5231 6.47715 22.0002 12 22.0002ZM12 24.0002C18.6274 24.0002 24 18.6277 24 12.0002C24 5.37283 18.6274 0.000244141 12 0.000244141C5.37258 0.000244141 0 5.37283 0 12.0002C0 18.6277 5.37258 24.0002 12 24.0002Z"
											fill="#252628"
										></path>
									</g>
									<defs>
										<clipPath id="clip0_3647_455">
											<rect
												width="24"
												height="24"
												fill="white"
												transform="translate(0 0.000244141)"
											></rect>
										</clipPath>
									</defs>
								</svg>
							</a>
						</li>
						<li
							class="_nav-button__burger"
							@click="showBurger"
							:class="darkMode ? 'dark-mode' : ''"
						>
							<template v-if="!burgerMenu">
								<svg
									xmlns="http://www.w3.org/2000/svg"
									width="24"
									height="24"
									viewBox="0 0 24 24"
									fill="none"
								>
									<path
										fill-rule="evenodd"
										clip-rule="evenodd"
										d="M2 4.00073C2 3.44845 2.44772 3.00073 3 3.00073H21C21.5523 3.00073 22 3.44845 22 4.00073C22 4.55302 21.5523 5.00073 21 5.00073H3C2.44772 5.00073 2 4.55302 2 4.00073ZM2 12.0007C2 11.4484 2.44772 11.0007 3 11.0007H21C21.5523 11.0007 22 11.4484 22 12.0007C22 12.553 21.5523 13.0007 21 13.0007H3C2.44772 13.0007 2 12.553 2 12.0007ZM2 20.0007C2 19.4484 2.44772 19.0007 3 19.0007H21C21.5523 19.0007 22 19.4484 22 20.0007C22 20.553 21.5523 21.0007 21 21.0007H3C2.44772 21.0007 2 20.553 2 20.0007Z"
										fill="#252628"
									></path>
								</svg>
							</template>
							<template v-else>
								<svg
									xmlns="http://www.w3.org/2000/svg"
									width="24"
									height="24"
									viewBox="0 0 24 24"
									fill="none"
								>
									<path
										fill-rule="evenodd"
										clip-rule="evenodd"
										d="M3.99992 4.0009C4.39045 3.61038 5.02361 3.61038 5.41414 4.0009L11.7782 10.365L18.1421 4.00119C18.5326 3.61067 19.1657 3.61067 19.5563 4.00119C19.9468 4.39172 19.9468 5.02488 19.5563 5.41541L13.1925 11.7792L19.5563 18.143C19.9468 18.5336 19.9468 19.1667 19.5563 19.5573C19.1657 19.9478 18.5326 19.9478 18.1421 19.5573L11.7782 13.1934L5.41414 19.5575C5.02361 19.9481 4.39045 19.9481 3.99992 19.5575C3.6094 19.167 3.6094 18.5339 3.99992 18.1433L10.364 11.7792L3.99992 5.41511C3.6094 5.02459 3.6094 4.39143 3.99992 4.0009Z"
										fill="#252628"
									></path>
								</svg>
							</template>
						</li>
					</ul>
				</div>
				<div
					class="_nav-first__mob"
					:class="darkMode ? 'dark-mode' : ''"
					v-if="burgerMenu"
				>
					<ul class="_nav-first__mob-links">
						<li
							v-for="(item, idx, arr) in navStore.getFirstLevel"
							:key="item.name"
						>
							<a
								@click.prevent="showSecondLevelMob(item, idx, arr)"
								class="_nav-first__mob-link"
								:href="item.url"
								:target="item._blank === 'Y' ? '_blank' : ''"
								data-metrika="menuSection"
								:class="item.selected === 'Y' ? 'active' : ''"
							>
								{{ item.name }}
							</a>
						</li>
					</ul>
					<div class="_nav-second__mob">
						<ul class="_nav-second__mob-links">
							<li v-for="(item, idx) in navStore.getSecondLevelMob" :key="item">
								<template v-if="item.only_responsive !== 'Y'">
									<a
										class="_nav-second__mob-link"
										:href="item.url"
										:target="item._blank === 'Y' ? '_blank' : ''"
										data-metrika="menuItem"
										:class="[
											item.selected === 'Y' ? 'active' : '',
											darkMode ? 'dark-mode' : '',
										]"
										@click.prevent="showThirdLevelMob(item, idx)"
									>
										{{ item.name }}
										<svg
											xmlns="http://www.w3.org/2000/svg"
											width="16"
											height="16"
											viewBox="0 0 16 16"
											fill="none"
										>
											<path
												fill-rule="evenodd"
												clip-rule="evenodd"
												d="M5.19912 3.18424C5.46462 2.93859 5.89507 2.93859 6.16056 3.18424L10.2702 6.98678C10.5766 7.27022 10.5766 7.72978 10.2702 8.01322L6.16056 11.8158C5.89507 12.0614 5.46462 12.0614 5.19912 11.8158C4.93363 11.5701 4.93363 11.1718 5.19912 10.9262L8.90204 7.5L5.19912 4.07383C4.93363 3.82817 4.93363 3.42989 5.19912 3.18424Z"
												fill="#252628"
											/>
										</svg>
									</a>
								</template>
								<template v-else>
									<a
										class="_nav-second__mob-responsive"
										:target="item._blank === 'Y' ? '_blank' : ''"
										@click="linkToPageResponsive(item)"
										:class="[
											item.selected === 'Y' ? 'active' : '',
											darkMode ? 'dark-mode' : '',
										]"
										data-metrika="menuItem"
										:href="item.url"
										v-for="item in item?.items"
									>
										{{ item.name }}
									</a>
								</template>
							</li>
						</ul>
						<div
							class="_nav-second__mob-static"
							:class="darkMode ? 'dark-mode' : ''"
						>
							<a
								class="mob-static__link mob-static__link-border"
								:class="darkMode ? 'dark-mode' : ''"
								data-metrika="menuItem"
								href="/about/"
								>Что такое ДОМ.РФ?
								<svg
									xmlns="http://www.w3.org/2000/svg"
									width="16"
									height="16"
									viewBox="0 0 16 16"
									fill="none"
								>
									<path
										fill-rule="evenodd"
										clip-rule="evenodd"
										d="M5.19912 3.18424C5.46462 2.93859 5.89507 2.93859 6.16056 3.18424L10.2702 6.98678C10.5766 7.27022 10.5766 7.72978 10.2702 8.01322L6.16056 11.8158C5.89507 12.0614 5.46462 12.0614 5.19912 11.8158C4.93363 11.5701 4.93363 11.1718 5.19912 10.9262L8.90204 7.5L5.19912 4.07383C4.93363 3.82817 4.93363 3.42989 5.19912 3.18424Z"
										fill="#252628"
									/>
								</svg>
							</a>
							<div
								class="_nav-second__mob-grid"
								:class="darkMode ? 'dark-mode' : ''"
							>
								<a
									class="mob-static__link mob-static__grid-news"
									href="/media/news/"
									>Новости</a
								>
								<a class="mob-static__link grid-contacts" href="/contacts/"
									>Контакты</a
								>
								<div class="mob-static__grid-phone">
									<span class="mob-static__label">Телефон компании</span>
									<p class="mob-static__text">+7 (495) 775-47-40</p>
								</div>
								<div class="mob-static__grid-consult">
									<span class="mob-static__label">Консультационный центр</span>
									<p class="mob-static__text">+7 (495) 775-47-40</p>
								</div>
								<div class="mob-static__grid-address">
									<span class="mob-static__label">Адрес</span>
									<p class="mob-static__text">Москва, Воздвиженка, 10</p>
								</div>
								<div class="mob-static-soc__wrp mob-static__grid-social">
									<div class="mob-static-soc">
										<a
											class="mob-static-soc__tg"
											href="http://"
											target="_blank"
										>
											<img src="./assets/images/socials/tg-mob.svg" alt="" />
										</a>
										<a
											class="mob-static-soc__vk"
											href="http://"
											target="_blank"
										>
											<img src="./assets/images/socials/vk-mob.svg" />
										</a>
										<a
											class="mob-static-soc__yt"
											href="http://"
											target="_blank"
										>
											<img src="./assets/images/socials/yt-mob.svg" />
										</a>
									</div>
									<div class="mob-static-lang">
										<a href="https://domrf.com/" target="_blank">
											<svg
												xmlns="http://www.w3.org/2000/svg"
												width="30"
												height="24"
												viewBox="0 0 30 24"
												fill="none"
											>
												<path
													d="M7.15907 16.9571H12.9792V19H5V6H12.8853V8.04286H7.15907V11.4229H12.4159V13.4471H7.15907V16.9571Z"
													fill="#252628"
												/>
												<path
													d="M22.8409 6H25V19H23.3103L17.1147 10.1786V19H14.9556V6H16.6453L22.8409 14.8214V6Z"
													fill="#252628"
												/></svg
										></a>
										<a href="https://domrf.com/cn/" target="_blank">
											<svg
												xmlns="http://www.w3.org/2000/svg"
												width="31"
												height="24"
												viewBox="0 0 31 24"
												fill="none"
											>
												<path
													d="M0 6.784H13.232V14.816H11.216V8.672H1.936V14.896H0V6.784ZM1.008 12.112H12.336V14H1.008V12.112ZM5.552 4H7.584V19.024H5.552V4Z"
													fill="#252628"
												/>
												<path
													d="M25.664 7.568L27.712 8.16C25.696 13.92 21.968 17.28 16.24 19.072C16.016 18.592 15.408 17.664 15.024 17.2C20.56 15.744 24 12.784 25.664 7.568ZM19.488 7.696C21.104 12.432 24.56 15.84 30.256 17.12C29.792 17.568 29.168 18.48 28.864 19.04C22.864 17.472 19.568 13.808 17.568 8.272L19.488 7.696ZM15.312 6.528H29.968V8.416H15.312V6.528ZM21.6 4H23.584V7.68H21.6V4Z"
													fill="#252628"
												/></svg
										></a>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<modal
					ref="modal"
					:class="darkMode ? 'dark-mode' : ''"
					:darkMode="darkMode"
				>
					<template v-slot:header>
						{{ currentName }}
					</template>
					<template v-slot:body>
						<div class="_nav-third-mob__list">
							<TransitionGroup name="list">
								<div
									class="_nav-third-mob__block"
									v-for="(item, idx) in navStore.getThirdLevel"
									:key="item"
								>
									<template v-if="Array.isArray(item)">
										<div
											class="_nav-third__block-inn"
											v-for="(items, idx) in item"
											:key="item"
										>
											<div
												class="_nav-third-mob__title"
												:class="darkMode ? 'dark-mode' : ''"
												v-for="(item, idx) in items"
												:key="item"
											>
												<span>
													{{ item.name }}
												</span>
												<ul class="_nav-third-mob__links">
													<li v-for="(item, idx) in item.items" :key="item">
														<a
															class="_nav-third-mob__link"
															:href="item.url"
															:target="item._blank === 'Y' ? '_blank' : ''"
															data-metrika="menuLink"
															@click.prevent="linkToPage(item)"
															:class="
																item.url === activePathName ? 'active' : ''
															"
														>
															{{ item.name }}
														</a>
													</li>
												</ul>
											</div>
										</div>
									</template>
									<template v-else>
										<div
											class="_nav-third-mob__title"
											:class="darkMode ? 'dark-mode' : ''"
											v-for="(item, idx) in item.sections"
											:key="item"
										>
											<span>
												{{ item.name }}
											</span>
											<ul class="_nav-third-mob__links">
												<li
													v-for="(item, idx) in item.items"
													:key="item"
													:class="
														item?.img !== '' && item?.type !== 'footnote'
															? 'app-link'
															: 'site__link'
													"
												>
													<template v-if="item.img">
														<a
															class="_nav-third-mob__link _nav-third-mob__link-img"
															:href="item.url"
															:target="item._blank === 'Y' ? '_blank' : ''"
															data-metrika="menuLink"
															:class="
																item.url === activePathName ? 'active' : ''
															"
														>
															<img
																:src="[darkMode ? item.img_dark : item.img]"
																:alt="item.name"
															/>
														</a>
													</template>
													<template v-else-if="item?.type === 'footnote'">
														<a
															class="_nav-third-mob__link-footnote"
															:href="item.url"
															:target="item._blank === 'Y' ? '_blank' : ''"
															data-metrika="menuLink"
															:class="[
																item.url === activePathName ? 'active' : '',
																darkMode ? 'dark-mode' : '',
															]"
														>
															<svg
																width="24"
																height="24"
																viewBox="0 0 12 12"
																fill="none"
																xmlns="http://www.w3.org/2000/svg"
															>
																<path
																	fill-rule="evenodd"
																	clip-rule="evenodd"
																	d="M9.43586 1.24296C9.44329 0.860539 9.1393 0.556548 8.75688 0.563976L2.52499 0.685026C2.14257 0.692454 1.82654 1.00849 1.81911 1.39091C1.81168 1.77333 2.11567 2.07732 2.49809 2.06989L7.0583 1.98131L0.776305 8.26331C0.500641 8.53897 0.492125 8.9774 0.757284 9.24256C1.02244 9.50772 1.46087 9.4992 1.73653 9.22353L8.01853 2.94154L7.92995 7.50175C7.92252 7.88417 8.22651 8.18816 8.60893 8.18073C8.99135 8.1733 9.30739 7.85727 9.31481 7.47485L9.43586 1.24296Z"
																	fill="#82BF00"
																/>
															</svg>
															{{ item.name }}
														</a>
													</template>
													<template v-else>
														<a
															class="_nav-third-mob__link"
															:href="item.url"
															@click.prevent="linkToPage(item)"
															data-metrika="menuLink"
															:class="[
																item.url === activePathName ? 'active' : '',
																darkMode ? 'dark-mode' : '',
															]"
														>
															{{ item.name }}
														</a>
													</template>
												</li>
											</ul>
										</div>
									</template>
								</div>
							</TransitionGroup>
						</div>
					</template>
				</modal>
				<div class="_nav-second" v-if="navStore.getSecondLevel?.length > 0">
					<ul class="_nav-second__links" :class="darkMode ? 'dark-mode' : ''">
						<template v-for="(item, idx) in navStore.getSecondLevel" :key="idx">
							<li v-if="item.only_responsive !== 'Y'">
								<a
									class="_nav-second__link"
									:href="item.url"
									:target="item._blank === 'Y' ? '_blank' : ''"
									:class="[
										item.selected === 'Y' ? 'active' : '',
										darkMode ? 'dark-mode' : '',
									]"
									data-metrika="menuItem"
									@click.prevent="showThirdLevel(item, idx)"
								>
									{{ item.name }}
								</a>
							</li>
						</template>
					</ul>
				</div>
				<transition name="fade">
					<div
						class="_nav-third-bg"
						:class="darkMode ? 'dark-mode' : ''"
						v-if="ShowThird && thirdLevel?.length > 0"
					>
						<div
							class="_nav-third"
							:class="[
								ShowThird ? 'left-fixed' : '',
								darkMode ? 'dark-mode' : '',
							]"
						>
							<div class="_nav-third-wrapper">
								<div class="_nav-third-list">
									<TransitionGroup name="list">
										<div
											class="_nav-third__block"
											v-for="(item, idx) in navStore.getThirdLevel"
											:key="idx"
										>
											<template v-if="Array.isArray(item)">
												<div
													class="_nav-third__block-inn"
													v-for="(items, idx) in item"
													:key="idx"
												>
													<div
														class="_nav-third__title"
														:class="darkMode ? 'dark-mode' : ''"
														v-for="(item, idx) in items"
														:key="idx"
													>
														<span>
															{{ item.name }}
														</span>
														<ul class="_nav-third__links">
															<li v-for="(item, idx) in item.items" :key="idx">
																<a
																	class="_nav-third__link"
																	@click.prevent="linkToPage(item)"
																	:href="item.url"
																	:target="item._blank === 'Y' ? '_blank' : ''"
																	data-metrika="menuLink"
																	:class="[
																		item.url === activePathName ? 'active' : '',
																		darkMode ? 'dark-mode' : '',
																	]"
																>
																	{{ item.name }}
																	{{ item }}
																</a>
															</li>
														</ul>
													</div>
												</div>
											</template>
											<template v-else>
												<div
													class="_nav-third__title"
													:class="darkMode ? 'dark-mode' : ''"
													v-for="(item, idx) in item.sections"
													:key="idx"
												>
													<span>
														{{ item.name }}
													</span>
													<ul class="_nav-third__links">
														<li
															v-for="(item, idx) in item.items"
															:key="idx"
															:class="
																item?.img !== '' && item?.type !== 'footnote'
																	? 'app-link'
																	: ''
															"
														>
															<template v-if="item.img">
																<a
																	class="_nav-third__link _nav-third__link-img"
																	:href="item.url"
																	:target="item._blank === 'Y' ? '_blank' : ''"
																	data-metrika="menuLink"
																	:class="[
																		item.url === activePathName ? 'active' : '',
																		darkMode ? 'dark-mode' : '',
																	]"
																>
																	<img
																		:src="darkMode ? item.img_dark : item.img"
																		:alt="item.name"
																	/>
																</a>
															</template>
															<template v-else-if="item?.type === 'footnote'">
																<a
																	class="_nav-third__link-footnote"
																	:href="item.url"
																	:target="item._blank === 'Y' ? '_blank' : ''"
																	data-metrika="menuLink"
																	:class="[
																		item.url === activePathName ? 'active' : '',
																		darkMode ? 'dark-mode' : '',
																	]"
																>
																	<svg
																		width="24"
																		height="24"
																		viewBox="0 0 24 24"
																		fill="none"
																		xmlns="http://www.w3.org/2000/svg"
																	>
																		<path
																			fill-rule="evenodd"
																			clip-rule="evenodd"
																			d="M5.68746 6C5.68746 5.44772 6.13518 5 6.68746 5H17C17.5523 5 18 5.44772 18 6V16.3125C18 16.8648 17.5523 17.3125 17 17.3125C16.4477 17.3125 16 16.8648 16 16.3125V8.41423L6.70711 17.7072C6.31659 18.0978 5.68342 18.0978 5.2929 17.7072C4.90237 17.3167 4.90237 16.6836 5.29289 16.293L14.5858 7H6.68746C6.13518 7 5.68746 6.55228 5.68746 6Z"
																			fill="#82BF00"
																		/>
																	</svg>
																	{{ item.name }}
																</a>
															</template>
															<template v-else>
																<a
																	class="_nav-third__link"
																	@click.prevent="linkToPage(item)"
																	:href="item.url"
																	:target="item._blank === 'Y' ? '_blank' : ''"
																	data-metrika="menuLink"
																	:class="[
																		item.url === activePathName ? 'active' : '',
																		darkMode ? 'dark-mode' : '',
																	]"
																>
																	{{ item.name }}
																</a>
															</template>
														</li>
													</ul>
												</div>
											</template>
										</div>
									</TransitionGroup>
								</div>
								<div
									class="_nav-third__close-btn"
									:class="darkMode ? 'dark-mode' : ''"
									@click="ShowThird = false"
								>
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="40"
										height="40"
										viewBox="0 0 40 40"
										fill="none"
									>
										<rect
											x="0.5"
											y="0.5"
											width="39"
											height="39"
											rx="19.5"
											stroke="#252628"
										></rect>
										<path
											fill-rule="evenodd"
											clip-rule="evenodd"
											d="M14.6669 14.6667C14.9273 14.4063 15.3494 14.4063 15.6098 14.6667L19.8525 18.9094L24.095 14.6669C24.3554 14.4065 24.7775 14.4065 25.0378 14.6669C25.2982 14.9272 25.2982 15.3494 25.0378 15.6097L20.7953 19.8522L25.0378 24.0948C25.2982 24.3551 25.2982 24.7772 25.0378 25.0376C24.7775 25.2979 24.3554 25.2979 24.095 25.0376L19.8525 20.7951L15.6098 25.0378C15.3494 25.2981 14.9273 25.2981 14.6669 25.0378C14.4066 24.7774 14.4066 24.3553 14.6669 24.095L18.9097 19.8522L14.6669 15.6095C14.4066 15.3492 14.4066 14.927 14.6669 14.6667Z"
											fill="#252628"
										></path>
									</svg>
								</div>
							</div>
						</div>
					</div>
				</transition>
				<div
					class="_nav-all-directions-popup"
					:class="showDirection ? 'active' : ''"
				>
					<transition name="direction">
						<direction
							ref="directions"
							:darkMode="darkMode"
							:directions="navStore.getAllDirections"
							v-if="showDirection"
							@closeAllDirection="showDirection = false"
						></direction>
					</transition>
				</div>
			</div>
		</div>
		<teleport
			:to="showDirection ? '._nav-logo' : '#header-menu'"
			v-if="ShowThird || showDirection"
		>
			<div class="blur-body"></div>
		</teleport>
	</nav>
	<ScrollToTop></ScrollToTop>
</template>

<script>
import Direction from './assets/components/Direction.vue'
import Modal from './assets/components/ModalBlock.vue'
import { mapStores, mapState } from 'pinia'
import { useNavStore } from './stores/store'
import { throttle } from 'throttle-debounce'
import ScrollToTop from './assets/components/scrollToTop.vue'

export default {
	components: {
		Direction,
		Modal,
		ScrollToTop,
	},
	data() {
		return {
			ShowThird: false,
			activeTab: 0,
			bxPanel: false,
			openSelect: false,
			showDirection: false,
			burgerMenu: false,
			currentName: null,
			darkMode: false,
			firstLink: '',
			secondLink: '',
			thirdLink: '',
			metrika: { menuSection: '', menuItem: '', menuLink: '' },
		}
	},
	watch: {
		ShowThird(newValue, oldValue) {
			newValue ? this.fixedBody(true) : this.fixedBody(false)
		},
		showDirection(newValue, oldValue) {
			newValue ? this.fixedBody(true) : this.fixedBody(false)
		},
		burgerMenu(newValue, oldValue) {
			newValue ? this.fixedBody(true) : this.fixedBody(false)
		},
	},
	computed: {
		...mapStores(useNavStore),
		...mapState(useNavStore, [
			'firstLevel',
			'activePathName',
			'secondLevel',
			'thirdLevel',
			'setNewPathName',
		]),
		objMetrika() {
			let obj = JSON.parse(
				`{"URL":"${window.location.origin}","menuSection":{"${this.firstLink}":{"menuItem":{"${this.secondLink}":{"menuLink":"${this.thirdLink}"}}}}}`
			)
			function removeEmptyValue(object) {
				Object.keys(object).forEach(k => {
					if (typeof object[k] === 'object') {
						removeEmptyValue(object[k])
					}
					if (object[k] === '' || k === '') delete object[k]
				})
				return object
			}
			return removeEmptyValue({ ...obj })
		},
	},
	beforeMount() {
		this.navStore.getNavList()
	},
	mounted() {
		document.addEventListener('click', this.handleClickOutside)
		window.addEventListener('resize', throttle(300, this.resetModal))
		this.checkDarkMode()
		this.resetModal()
		this.detectBxPanel()
		let activeIndex = this.navStore.getFirstLevel.findIndex(
			el => el.selected === 'Y'
		)
		this.firstLink = this.navStore.getFirstLevel[activeIndex].name
	},
	unmounted() {
		document.removeEventListener('click', this.handleClickOutside)
		window.removeEventListener('scroll', this.checkScroll)
	},
	methods: {
		setMetrika(attr, text) {
			this.metrika.menuSection = ''
			if (attr === 'menuItem') {
				this.metrika.menuLink = ''
			} else if (attr === 'menuSection') {
				this.metrika.menuItem = ''
				this.metrika.menuLink = ''
			}
			for (let key in this.metrika) {
				if (key === attr) {
					this.metrika[key] = text
				}
				if (this.metrika.menuSection === '') {
					let key = this.navStore.getFirstLevel.find(
						el => el.selected === 'Y'
					).name
					this.metrika.menuSection = key
				}
			}
			this.firstLink = this.metrika.menuSection
			this.secondLink = this.metrika.menuItem
			this.thirdLink = this.metrika.menuLink
			this.sendMetrika(this.objMetrika)
		},
		linkToPageResponsive(item) {
			if (item?._blank === 'Y') {
				window.open(item.url, '_blank')
			} else {
				window.location = item.url
			}
		},
		linkToPage(item) {
			if (
				window.location.pathname + window.location.hash === item.url &&
				this.ShowThird
			) {
				this.ShowThird = false
				this.$refs.modal.closeModal()
				this.burgerMenu = false
				let elTo = document.getElementById(item.url.split('#')[1])
				if (elTo) {
					window.innerWidth > 1225
						? (elTo.style.scrollMarginTop = 140 + 'px')
						: (elTo.style.scrollMarginTop = 75 + 'px')
					elTo.scrollIntoView({ behavior: 'smooth' })
				}
			} else {
				this.setNewPathName(item.url)
				let elTo = document.getElementById(item.url.split('#')[1])
				if (elTo) {
					window.innerWidth > 1225
						? (elTo.style.scrollMarginTop = 140 + 'px')
						: (elTo.style.scrollMarginTop = 75 + 'px')
					elTo.scrollIntoView({ behavior: 'smooth' })
				}

				if (item?._blank === 'Y') {
					window.open(item.url, '_blank')
				} else {
					window.location = item.url
				}
				this.ShowThird = false
				this.$refs.modal.closeModal()
				this.burgerMenu = false
			}
			this.fixedBody(false)
		},
		navMainClick(item) {
			// this.firstLink = item.name;
			// this.secondLink = '';
			// this.thirdLink = item.name;
			// this.sendMetrika(this.objMetrika);
		},
		showSecondLevelMob(item, id, arr) {
			if (item?.url !== '' && !item.sections) {
				window.location = item.url
			} else {
				this.navStore.fillSecondLevelMob(item, id)
				this.navStore.firstLevel.forEach(el => (el.selected = 'N'))
				item.selected = 'Y'
			}
		},
		showThirdLevel(item, idx) {
			const activeEl = this.secondLevel.findIndex(el => el.selected === 'Y')
			if (activeEl !== -1) {
				this.secondLevel[activeEl].selected = 'N'
			}

			if (item.url !== '' && !item.sections) {
				if (item?._blank === 'Y') {
					window.open(item.url, '_blank')
				} else {
					window.location = item.url
				}
			}
			if (this.ShowThird && item.name === this.secondLevel[activeEl].name) {
				this.ShowThird = false
				return
			}
			this.navStore.activeThirdLevel(item, this.activeTab)
			item.selected = 'Y'
			if (this.thirdLevel?.length > 0) {
				this.ShowThird = true
			}
		},
		showThirdLevelMob(item, idx) {
			this.currentName = item.name
			this.navStore.activeThirdLevelMob(item)
			if (this.thirdLevel?.length > 0) {
				this.$refs.modal.openModal()
			} else if (item?.url !== '') {
				window.location = item.url
			}
			this.fixedBody(true)
		},
		handleClickOutside(event) {
			if (event.target.hasAttribute('data-metrika')) {
				let attr = event.target.getAttribute('data-metrika')
				let text = event.target.innerText
				this.setMetrika(attr, text)
			}

			if (
				(this.$refs.nav && !this.$refs.nav.contains(event.target)) ||
				this.$refs.directions
			) {
				if (this.ShowThird) {
					this.ShowThird = false
				}
			}

			if (
				this.$refs.selectLang &&
				!this.$refs.selectLang.contains(event.target)
			) {
				if (this.openSelect) {
					this.openSelect = false
				}
			}
		},
		setLang(event) {
			event.preventDefault()
			this.openSelect = !this.openSelect
		},
		showAllDirection() {
			this.showDirection = !this.showDirection
			setTimeout(() => {
				this.$refs.directions.outsideListener()
			}, 0)
		},
		showBurger() {
			this.burgerMenu = !this.burgerMenu
		},
		fixedBody(param) {
			param
				? document.querySelector('body').classList.add('body-lock-scroll')
				: document.querySelector('body').classList.remove('body-lock-scroll')
		},
		resetModal() {
			if (window.innerWidth >= 1224) {
				this.burgerMenu = false
			} else {
				this.ShowThird = false
			}
			let header = document.getElementById('header-nav')
			if (this.navStore.getSecondLevel?.length && window.innerWidth > 1224) {
				header.style.minHeight = 140 + 'px'
			} else {
				header.removeAttribute('style')
			}
		},
		checkDarkMode() {
			let dm = document.querySelector('.page-theme-dark')
			if (dm) {
				this.darkMode = true
			}
		},
		detectBxPanel() {
			const bxPanel = document.querySelector('#bx-panel')
			if (bxPanel) {
				window.addEventListener('scroll', throttle(300, this.checkScroll))
				this.bxPanel = true
			}
		},
		checkScroll() {
			if (window.scrollY > 30) {
				this.bxPanel = false
			} else {
				this.bxPanel = true
			}
		},
		sendMetrika(obj) {
			if (typeof yaCounter50230510 === 'object') {
				yaCounter50230510.reachGoal('menu-click', obj)
			}
		},
	},
}
</script>

<style lang="scss" scoped>
@import 'assets/styles/mixin/typography';

._nav {
	&-logo {
		&.dark-mode {
			svg path {
				fill: #fff;
			}
		}

		@media (max-width: 1224px) {
			svg {
				max-width: 40px;
				max-height: 40px;
			}
		}
	}

	background-color: #fff;
	position: fixed;
	top: 0;
	width: 100vw;
	z-index: 313;

	&-container {
		display: grid;
		grid-template-columns: 50px 170px 1fr 1fr auto;
		grid-template-rows: none;
		grid-template-areas:
			'logo all_directions main_menu inner_menu button_block'
			'second_nav second_nav second_nav second_nav second_nav';
		align-items: center;
		justify-content: space-between;
		margin: 0 auto;
		max-width: 100rem;
		padding: 1rem 2.5rem;

		@media (max-width: 1499px) {
			grid-template-columns: 40px 48px 1fr 1fr auto;
			grid-template-areas:
				'all_directions_m logo main_menu inner_menu button_block'
				'second_nav second_nav second_nav second_nav second_nav';
		}

		@media (max-width: 1224px) {
			grid-template-areas:
				'all_directions_m logo main_menu inner_menu button_block'
				'nav_first_mob nav_first_mob nav_first_mob nav_first_mob nav_first_mob';
		}

		@media (max-width: 1123px) {
			padding: 1rem;
		}

		@media (max-width: 768px) {
			grid-template-columns: 30px 40px 1fr 1fr auto;
		}
	}

	&-wrapper {
	}

	&-log {
		grid-area: logo;
		cursor: pointer;
	}

	&-all-directions {
		@include gilroy-600;
		font-size: 16px;
		line-height: 24px;
		grid-area: all_directions;
		display: flex;
		align-items: center;
		margin-left: 16px;
		color: #252628;
		cursor: pointer;
		position: inherit;
		transition: color 0.2s ease-in-out;

		@media (max-width: 1499px) {
			display: none;
		}

		&__mob {
			grid-area: all_directions_m;
			cursor: pointer;

			@media (min-width: 1500px) {
				display: none;
			}
		}

		& span {
			white-space: nowrap;
		}

		&.dark-mode {
			span {
				color: #fff;
			}

			&:hover span {
				color: #67a511;
			}

			svg path {
				fill: #fff;
			}
		}

		svg {
			margin-left: 4px;

			path {
				transition: fill 0.2s ease-in-out;
			}
		}

		&:hover {
			color: #67a511;

			svg path {
				transition: fill 0.2s ease-in-out;
				fill: #67a511;
			}
		}

		&-popup {
			position: fixed;
			left: 0;
			top: 0;
			z-index: 313;
			height: 100vh;
			height: 100dvh;

			&.active {
				@media (max-width: 820px) {
					right: 0;
				}
			}
		}
	}

	&-main {
		grid-area: main_menu;
		display: flex;
		align-items: center;
		justify-content: flex-start;
		margin-left: 40px;

		@media (max-width: 1390px) {
			margin-left: 20px;
		}

		@media (max-width: 1224px) {
			display: none;
		}

		&__link {
			@include gilroy-600;
			font-size: 16px;
			line-height: 24px;
			color: #6d6d6d;
			white-space: nowrap;
			transition: color 0.2s ease-in-out;
			cursor: pointer;

			&:hover {
				color: #67a511;
			}

			&.active {
				color: #67a511;
			}

			&.dark-mode {
				color: #999;

				&:hover {
					color: #67a511;
				}

				&.active {
					color: #67a511;
				}
			}
		}
	}

	&-inner {
		grid-area: inner_menu;
		display: flex;
		align-items: center;
		justify-content: flex-end;
		margin-right: 40px;

		@media (max-width: 1390px) {
			margin-right: 20px;
		}

		@media (max-width: 1224px) {
			display: none;
		}

		&__link {
			@include gilroy-600;
			font-size: 16px;
			line-height: 24px;
			color: #6d6d6d;
			white-space: nowrap;
			transition: color 0.2s ease-in-out;

			&:hover {
				color: #67a511;
			}

			&.active {
				color: #67a511;
			}

			&.dark-mode {
				color: #999;

				&:hover {
					color: #67a511;
				}

				&.active {
					color: #67a511;
				}
			}
		}
	}

	&-first__mob {
		grid-area: nav_first_mob;
		background: linear-gradient(
			180deg,
			rgba(50, 50, 50, 0.05) 0%,
			rgb(255, 255, 255) 100%
		);
		position: absolute;
		z-index: 310;
		background-color: #fff;
		top: 99%;
		width: 100%;
		height: calc(100vh - 74px);
		height: calc(100dvh - 74px);
		margin-left: 50%;
		transform: translate(-50%, 0);
		left: 0;
		border-top: 1px solid #efefef;
		padding: 24px 0 16px 16px;
		display: flex;
		flex-direction: column;

		&.dark-mode {
			background: linear-gradient(
				180deg,
				rgba(50, 50, 50, 0.05) 0%,
				rgb(37, 38, 40) 100%
			);
			background-color: #252628;
			border-top: 1px solid #494c4b;

			._nav-first__mob-link {
				color: #fff;
				background: #252628;
				border: 1px solid #6d6d6d;

				&.active {
					color: #252628;
					background: #fff;
					border: 1px solid #fff;
				}

				&:hover {
					color: #252628;
					background: #fff;
					border: 1px solid #67a511;
				}
			}
		}

		@media (min-width: 1225px) {
			display: none;
		}

		&-links {
			display: flex;
			gap: 8px;
			overflow-x: auto;
			padding-bottom: 8px;
			min-height: 50px;
			margin-right: 16px;
		}

		&-link {
			@include gilroy-600;
			font-size: 14px;
			line-height: 40px;
			color: #252628;
			border-radius: 26px;
			border: 1px solid #dedede;
			display: inline-block;
			padding: 0 24px;
			white-space: nowrap;
			cursor: pointer;

			&.active {
				color: #fff;
				background-color: #252628;
				border: 1px solid #252628;
			}
		}
	}

	&-button {
		&__block {
			grid-area: button_block;
		}

		&__list {
			display: flex;
			align-items: center;
		}

		&__lang {
			position: relative;

			svg {
				margin-left: 4px;
			}

			@media (max-width: 1224px) {
				display: none;
			}

			a {
				display: flex;
				align-items: center;
				@include gilroy-600;
				font-size: 16px;
				line-height: 24px;
				color: #252628;
				transition: color 0.2s ease-in-out;

				&:hover {
					color: #67a511;

					svg path {
						fill: #67a511;
					}
				}

				&.active {
					color: #67a511;
				}
			}

			&.dark-mode {
				a {
					color: #fff;

					&:hover {
						color: #67a511;

						svg path {
							fill: #67a511;
						}
					}

					&.active {
						color: #67a511;
					}

					svg path {
						fill: #fff;
					}
				}
			}

			& .select-choose {
				position: absolute;
				top: 100%;
				left: 0;
				padding: 12px 16px;
				border-radius: 16px;
				background-color: #fff;
				z-index: 311;
				box-shadow: 0px 8px 40px 0px rgba(30, 27, 27, 0.1);

				&__lang {
					white-space: nowrap;
				}

				&.dark-mode {
					background-color: #252628;
					border: 1px solid #1e1b1b;

					a {
						color: #fff;
					}
				}

				a {
					color: #252628;

					&:hover {
						color: #67a511;
					}
				}
			}
		}

		&__lk {
			&:hover {
				svg path {
					fill: #67a511;
				}
			}

			&.dark-mode {
				svg path {
					fill: #fff;
				}

				&:hover {
					svg path {
						fill: #67a511;
					}
				}
			}
		}

		@media (max-width: 1224px) {
			display: none;
		}

		&__search {
			margin: 0 20px;

			&:hover {
				svg path {
					fill: #67a511;
				}
			}

			&.dark-mode {
				svg path {
					fill: #fff;
				}

				&:hover {
					svg path {
						fill: #67a511;
					}
				}
			}
		}

		&__burger {
			margin-left: 16px;
			cursor: pointer;

			@media (min-width: 1225px) {
				display: none;
			}

			&.dark-mode {
				svg path {
					fill: #fff;
				}
			}
		}
	}

	&-second {
		grid-area: second_nav;
		position: relative;

		&__links {
			display: flex;
			align-items: center;
			justify-content: flex-start;
			gap: 24px;
			border-top: 1px solid #efefef;
			padding-top: 16px;
			margin-top: 16px;

			&.dark-mode {
				border-top: 1px solid #494c4b;
			}
		}

		&__link {
			@include gilroy-600;
			font-size: 16px;
			line-height: 24px;
			color: #252628;
			white-space: nowrap;
			transition: color 0.2s ease-in-out;
			cursor: pointer;

			&:hover {
				color: #67a511;
			}

			&.active {
				color: #67a511;
			}

			&.dark-mode {
				color: #fff;

				&:hover {
					color: #82bf00;
				}

				&.active {
					color: #67a511;
				}
			}
		}

		@media (max-width: 1224px) {
			display: none;
		}
	}

	&-second__mob {
		grid-area: second_nav;
		position: relative;
		overflow-y: auto;
		padding-right: 16px;
		overflow-x: hidden;

		&-links {
			display: flex;
			align-items: flex-start;
			flex-direction: column;
			justify-content: flex-start;
			padding-top: 14px;

			& li {
				width: 100%;
			}
		}

		&-link {
			@include gilroy-600;
			font-size: 16px;
			line-height: 24px;
			color: #252628;
			white-space: nowrap;
			transition: color 0.2s ease-in-out;
			padding: 10px 0;
			cursor: pointer;
			display: flex;
			width: 100%;
			justify-content: space-between;
			align-items: center;

			@media (min-width: 560px) {
				& svg {
					min-width: 24px;
					min-height: 24px;
				}
			}

			&:hover {
				color: #67a511;
			}

			&.active {
				color: #67a511;
			}

			&.dark-mode {
				color: #fff;

				&:hover {
					color: #67a511;
				}

				&.active {
					color: #67a511;
				}

				& svg path {
					fill: #fff;
				}
			}
		}

		&-responsive {
			@include gilroy-600;
			font-size: 16px;
			line-height: 24px;
			color: #252628;
			white-space: nowrap;
			transition: color 0.2s ease-in-out;
			cursor: pointer;
			padding-bottom: 12px;
			border-bottom: 1px solid #e6e6e6;
			display: inline-block;
			margin-bottom: 10px;
			width: 100%;

			@media (min-width: 560px) {
				border-top: 1px solid #e6e6e6;
				padding: 12px 0;
			}

			&:hover {
				color: #67a511;
			}

			&.active {
				color: #67a511;
			}

			&.dark-mode {
				border-top: 1px solid #494c4b;
				border-bottom: 1px solid #494c4b;
				color: #fff;

				@media (max-width: 560px) {
					padding-top: 12px;
				}

				&:hover {
					color: #67a511;
				}

				&.active {
					color: #67a511;
				}
			}
		}

		&-grid {
			display: grid;
			grid-template-columns: 1fr;
			grid-template-rows: none;
			grid-template-areas:
				'news' 'contacts' 'phone'
				'consult' 'address' 'social';
			grid-auto-flow: column;

			@media (min-width: 560px) {
				grid-template-areas:
					'news phone'
					'contacts phone'
					'contacts consult'
					'social address';
				grid-template-columns: 50% 50%;
				grid-column-gap: 20px;
			}

			&.dark-mode {
				a,
				p {
					color: #fff;
				}

				&:hover {
					color: #67a511;
				}

				&.active {
					color: #67a511;
				}

				& svg path {
					fill: #fff;
				}
			}
		}

		&-static {
			border-top: 1px solid #e6e6e6;
			padding-top: 10px;
			margin-top: 10px;

			@media (min-width: 560px) {
				border-top: none;
				padding-top: 0;
				margin-top: 0;
			}

			&.dark-mode {
				border-top: 1px solid #494c4b;
			}

			.mob-static__link {
				@include gilroy-600;
				font-size: 16px;
				line-height: 24px;
				color: #252628;
				display: flex;
				width: 100%;
				justify-content: space-between;
				align-items: center;
				padding: 10px 0;

				&-border {
					@media (min-width: 560px) {
						border-top: 1px solid #e6e6e6;
						border-bottom: 1px solid #e6e6e6;
					}

					&.dark-mode {
						@media (min-width: 560px) {
							border-top: 1px solid #494c4b;
							border-bottom: 1px solid #494c4b;
						}
					}
				}

				@media (min-width: 560px) {
					padding: 12px 0;

					& svg {
						min-width: 24px;
						min-height: 24px;
					}
				}

				&.dark-mode {
					color: #fff;

					&:hover {
						color: #67a511;
					}

					&.active {
						color: #67a511;
					}

					& svg path {
						fill: #fff;
					}
				}
			}

			.mob-static {
				&__grid-news {
					grid-area: news;
					align-self: flex-start;
				}

				&__grid-contacts {
					grid-area: contacts;
					align-self: flex-start;
				}

				&__grid-phone {
					grid-area: phone;
					align-self: flex-start;
				}

				&__grid-consult {
					grid-area: consult;
					align-self: flex-start;

					@media (min-width: 560px) {
						position: relative;
						top: -10px;
					}
				}

				&__grid-address {
					grid-area: address;
					align-self: flex-start;
				}

				&__grid-social {
					grid-area: social;
					align-self: center;

					@media (min-width: 560px) {
						margin-right: 70px;
					}
				}
			}

			.mob-static__text {
				@include gilroy-600;
				font-size: 16px;
				line-height: 24px;
				color: #252628;
				padding-top: 8px;
				padding-bottom: 10px;
			}

			.mob-static__label {
				@include gilroy-500;
				color: #6d6d6d;
				font-size: 14px;
				line-height: 20px;
				margin-top: 10px;
				display: inline-block;
			}

			.mob-static-soc {
				display: flex;
				align-items: center;
				gap: 8px;
				margin: 10px 0;

				& svg {
					width: 30px;
				}

				&__tg,
				&__vk,
				&__yt {
					background-color: #f4f4f4;
					width: 32px;
					height: 32px;
					border-radius: 50%;
					display: flex;
					align-items: center;
					justify-content: center;
				}
			}

			.mob-static-lang {
				display: flex;
				align-items: center;
				justify-content: space-between;
				gap: 12px;
			}

			.mob-static-soc__wrp {
				display: flex;
				align-items: center;
				justify-content: space-between;
			}
		}

		@media (min-width: 1225px) {
			display: none;
		}
	}

	&-third {
		width: 100%;
		background: linear-gradient(
			180deg,
			rgba(50, 50, 50, 0.05) 0%,
			rgb(255, 255, 255) 100%
		);
		transition: padding 4.15s ease-in-out;

		&.left-fixed {
			padding-right: 17px;

			@media (max-width: 1224px) {
				padding-right: 0;
			}
		}

		&.dark-mode {
			background: linear-gradient(
				180deg,
				rgba(50, 50, 50, 0.05) 0%,
				rgb(37, 38, 40) 100%
			);
		}

		&-bg {
			position: absolute;
			top: 100%;
			width: 100%;
			background: #fff;
			left: 0;

			@media (max-width: 1224px) {
				display: none;
			}

			&.dark-mode {
				background: #2f2f31;
			}
		}

		&-wrapper {
			margin: 0 auto;
			max-width: 100rem;
			padding: 40px 2.5rem;
			display: flex;
			justify-content: space-between;
		}

		&-list {
			display: grid;
			grid-template-columns: repeat(auto-fit, minmax(100px, 295px));
			grid-column-gap: 40px;
			width: 100%;
		}

		&__block {
			max-width: 330px;
		}

		&__title {
			margin-bottom: 26px;

			& span {
				@include gilroy-600;
				font-size: 16px;
				line-height: 24px;
				color: #252628;
				margin-bottom: 14px;
				display: inline-block;
			}

			&.dark-mode span {
				color: #fff;
			}
		}

		&__links {
			&:has(._nav-third__link-img) {
				display: flex;
				flex-wrap: wrap;

				& .app-link {
					width: calc(100% / 2 - 12px);
				}

				& > li {
					margin-right: 12px;
				}
			}
		}

		&__link {
			@include gilroy-500;
			font-size: 16px;
			line-height: 24px;
			color: #6d6d6d;
			margin: 6px 0;
			display: inline-block;
			transition: color 0.2s ease-in-out;
			cursor: pointer;

			&:hover {
				color: #67a511;
			}

			&.active {
				color: #67a511;
			}

			&.dark-mode {
				color: #999;

				&.active {
					color: #67a511;
				}

				&:hover {
					color: #67a511;
				}
			}

			&-footnote {
				display: flex;
				align-items: flex-start;
				justify-content: flex-start;
				gap: 4px;
				padding-top: 8px;
				margin-bottom: 8px;
				border-top: 1px solid #e6e6e6;
				color: #252628;
				margin-top: 14px;
				@include gilroy-500;
				font-size: 16px;
				line-height: 24px;

				&:hover {
					color: #67a511;
				}
				&.dark-mode {
					color: #fff;
					border-top: 1px solid #494c4b;

					&:hover {
						color: #67a511;
					}
				}

				svg {
					flex: 1 0 auto;
				}
			}
		}

		&__close-btn {
			cursor: pointer;
			margin-right: 0;
			margin-left: auto;

			&.dark-mode {
				svg path {
					fill: #fff;
				}

				svg rect {
					stroke: #fff;
				}
			}
		}
	}

	&-third-mob {
		&__list {
			display: flex;
			flex-direction: column;
			width: 100%;

			@media (min-width: 933px) {
				display: grid;
				grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
				width: 100%;
			}
		}

		&__block {
			max-width: 330px;
		}

		&__title {
			margin-bottom: 24px;

			span {
				@include gilroy-600;
				font-size: 16px;
				line-height: 24px;
				color: #252628;
				margin-bottom: 10px;
				display: inline-block;
			}

			&.dark-mode {
				span {
					color: #fff;
				}
			}
		}

		&__links {
			&:has(._nav-third-mob__link-img) {
				display: flex;
				flex-wrap: wrap;
				gap: 6px;

				.app-link {
					width: calc(100% / 2 - 12px);

					a {
						margin-top: 8px;
						margin-bottom: 0;
					}
				}

				.site__link {
					margin-top: 10px;
				}

				@media (min-width: 560px) {
					.site__link {
						margin-top: 0;
					}

					flex-direction: row;
					gap: 12px;

					.app-link {
						width: calc(100% / 2 - 12px);
					}
				}
			}
		}

		&__link {
			@include gilroy-500;
			font-size: 16px;
			line-height: 24px;
			color: #6d6d6d;
			margin: 10px 0;
			display: inline-block;
			transition: color 0.2s ease-in-out;
			cursor: pointer;

			&.dark-mode {
				color: #999;

				&:hover {
					color: #67a511;
				}

				&.active {
					color: #67a511;
				}
			}

			&:hover {
				color: #67a511;
			}

			&.active {
				color: #67a511;
			}

			&-footnote {
				display: flex;
				justify-content: flex-start;
				align-items: center;
				gap: 6px;
				padding-top: 10px;
				margin: 10px 0;
				border-top: 1px solid #e6e6e6;
				color: #252628;
				@include gilroy-500;
				font-size: 16px;
				line-height: 24px;

				&.dark-mode {
					color: #fff;
					border-top: 1px solid #494c4b;
				}

				& svg {
					width: 16px;
				}
			}
		}

		&__close-btn {
			cursor: pointer;
			margin-right: 0;
			margin-left: auto;
		}
	}
}

#_nav {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	background-color: #fff;
	z-index: 310;
	transition: top 0.15s ease-in-out;
	box-shadow: 0px 12px 100px 0px rgba(50, 50, 50, 0.05);

	&.left-fixed {
		padding-right: 17px;

		@media (max-width: 1224px) {
			padding-right: 0;
		}
	}

	&.dark-mode {
		background-color: #252628;
	}

	&.bx-panel {
		top: 40px;
	}
}

._nav-links {
	gap: 24px;

	@media (max-width: 1260px) {
		gap: 14px;
	}
}

._nav-container {
	margin: 0 auto;
	width: 100%;
}

.flex {
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.blur-body {
	background: rgba(0, 0, 0, 0.6);
	bottom: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
	pointer-events: all;
	position: fixed;
	right: 0;
	top: 0;
	z-index: 312;
	cursor: auto;
}

.fade-enter-active {
	transition: all 0.3s ease;
}

.fade-leave-active {
	transition: all 0.15s ease;
}

.fade-enter-from {
	opacity: 0.5;
	transform: translateY(-5px);
}

.fade-enter-to {
	opacity: 1;
	transform: translateY(0);
}

.fade-leave-from {
	opacity: 1;
	transform: translateY(0);
	transform: translateX(8px);
}

.fade-leave-to {
	opacity: 0.5;
	transform: translateY(-5px);
	transform: translateX(9px);
}

.direction-enter-active {
	transition: all 0.5s ease;
}

.direction-leave-active {
	transition: all 0.5s ease;
}

.direction-enter-from {
	opacity: 0.8;
	transform: translateX(-100%);
}

.direction-enter-to {
	opacity: 1;
	transform: translateX(0);
}

.direction-leave-from {
	opacity: 1;
	transform: translateX(0);
}

.direction-leave-to {
	opacity: 0.8;
	transform: translateX(-100%);
}

.list-enter-active {
	transition: opacity 0.2s ease-in-out;
}

.list-leave-active {
}

.list-enter-from {
	opacity: 0;
}

.list-leave-to {
}
</style>
